
    export default 
    {
    "duplicate_order_confirm": {
        "dec1": "Abbiamo rilevato che hai già effettuato ordini ",
        "dec2": "con AliExpress in precedenza. Vuoi ancora effettuarli tramite AliExpress? Questo potrebbe creare ordini duplicati.",
        "input_confirm": "Inserisci CONFERMARE per effettuare gli ordini con AliExpress."
    }
}